import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import FormRenderer from "../../../components/generic/formbuilder/renderer/FormRenderer";
import "./modalformrenderer.css";
import { getContentId } from "../../../components/generic/formbuilder/networkservice/FormService";

const ModalFormRendererComponent = ({
  isModalOpen,
  footer,
  templateCode,
  formIdentifier,
  formSubmitCallback,
  setIsModalOpen,
}) => {
  const [title, setTitle] = useState("");

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    async function loadFormFromTemplateCode() {
      const contentIdObject = await getContentId(templateCode);
      setTitle(contentIdObject?.data?.title);
    }
    loadFormFromTemplateCode();
  }, [templateCode]);

  return (
    <div>
      <Modal
        destroyOnClose={true}
        bodyStyle={{ overflowY: "auto", marginTop: "60px", maxHeight: "75vh" }}
        centered
        okText={"Submit Form"}
        open={isModalOpen}
        onCancel={handleCloseModal}
        cancelButtonProps={{
          className: "custom-cancel-button",
        }}
        footer={footer}
        closable={true}
        title={title}
      >
        <FormRenderer
          templateCode={templateCode}
          formIdentifier={formIdentifier}
          formSubmitCallback={formSubmitCallback}
          isFormRenderedOnModal={true}
          className="modal-form-renderer"
        />
      </Modal>
    </div>
  );
};

export default ModalFormRendererComponent;
